import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';

import Router from './Router';
import { useAppDispatch } from './hooks/redux/hooks';
// import { useLocation } from 'react-router-dom';
import { setSearchValue } from './store/searchValue/searchValueSlice';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
function App() {

  return (
    <div className="App">

      <Router />
      <ToastContainer />
    </div>
  );
}


export default App;
